/*
 * Copyright © 2017 TEKTELIC Communications Inc.
 */
import HomeLinksRoutes from './home-links.routes';
import HomeLinksController from './home-links.controller';

export default angular.module('tektelic.homeLinks', [])
    .config(HomeLinksRoutes)
    .controller('HomeLinksController', HomeLinksController)
    .name;



// WEBPACK FOOTER //
// ./src/app/home/index.js